import type { CharacterProfile, RaidConfig } from './types';

export const sampleRaids: RaidConfig[] = [
  {
    id: 'dreamrift',
    name: 'The Dreamrift',
    shortName: 'DR',
    total: 1,
    source: 'blizzard'
  },
  {
    id: 'voidspire',
    name: 'The Voidspire',
    shortName: 'VS',
    total: 6,
    source: 'blizzard'
  },
  {
    id: 'march-on-queldanas',
    name: "March on Quel'Danas",
    shortName: 'MoQ',
    total: 2,
    source: 'blizzard'
  }
];

export const sampleCharacters: CharacterProfile[] = [
  {
    id: 'twilele-main',
    region: 'us',
    realm: 'illidan',
    name: 'Twilele',
    player: 'Twilele',
    className: 'Mage',
    level: 90,
    itemLevel: 287,
    role: 'ranged',
    priority: 'main',
    heroicLockouts: [
      { raidId: 'dreamrift', killed: 0, total: 1 },
      { raidId: 'voidspire', killed: 0, total: 6 },
      { raidId: 'march-on-queldanas', killed: 0, total: 2 }
    ],
    mythicLockouts: [
      { raidId: 'dreamrift', killed: 0, total: 1 },
      { raidId: 'voidspire', killed: 0, total: 6 },
      { raidId: 'march-on-queldanas', killed: 0, total: 2 }
    ]
  },
  {
    id: 'twilele-alt',
    region: 'us',
    realm: 'illidan',
    name: 'Twilealt',
    player: 'Twilele',
    className: 'Paladin',
    level: 90,
    itemLevel: 274,
    role: 'tank',
    priority: 'alt 1',
    heroicLockouts: [
      { raidId: 'dreamrift', killed: 1, total: 1 },
      { raidId: 'voidspire', killed: 3, total: 6 },
      { raidId: 'march-on-queldanas', killed: 0, total: 2 }
    ],
    mythicLockouts: [
      { raidId: 'dreamrift', killed: 1, total: 1 },
      { raidId: 'voidspire', killed: 0, total: 6 },
      { raidId: 'march-on-queldanas', killed: 0, total: 2 }
    ]
  },
  {
    id: 'nora-main',
    region: 'us',
    realm: 'illidan',
    name: 'Noramage',
    player: 'Nora',
    className: 'Priest',
    level: 90,
    itemLevel: 266,
    role: 'healer',
    priority: 'main',
    heroicLockouts: [
      { raidId: 'dreamrift', killed: 1, total: 1 },
      { raidId: 'voidspire', killed: 6, total: 6 },
      { raidId: 'march-on-queldanas', killed: 2, total: 2 }
    ],
    mythicLockouts: [
      { raidId: 'dreamrift', killed: 0, total: 1 },
      { raidId: 'voidspire', killed: 0, total: 6 },
      { raidId: 'march-on-queldanas', killed: 0, total: 2 }
    ]
  },
  {
    id: 'karn-alt',
    region: 'us',
    realm: 'area-52',
    name: 'Karnbear',
    player: 'Karn',
    className: 'Druid',
    level: 89,
    itemLevel: 252,
    role: 'melee',
    priority: 'alt 2',
    heroicLockouts: [
      { raidId: 'dreamrift', killed: 0, total: 1 },
      { raidId: 'voidspire', killed: 0, total: 6 },
      { raidId: 'march-on-queldanas', killed: 0, total: 2 }
    ],
    mythicLockouts: [
      { raidId: 'dreamrift', killed: 0, total: 1 },
      { raidId: 'voidspire', killed: 0, total: 6 },
      { raidId: 'march-on-queldanas', killed: 0, total: 2 }
    ]
  }
];

